import { useEffect } from "react";

import type { GridStateActions } from "./use-quote-board-grid-state.ts";

/**
 * Hook to handle grid reset functionality
 */
export const useQuoteBoardGridReset = (
	resetKey: number,
	shouldForceReset: boolean,
	hasProcessedInitialReset: React.MutableRefObject<boolean>,
	lastResetKeyRef: React.MutableRefObject<number>,
	actions: GridStateActions,
) => {
	// Reset filters when parent requests a refresh
	useEffect(() => {
		// Use local variables to avoid mutating hook arguments
		const hasProcessed = hasProcessedInitialReset.current;

		if (!hasProcessed) {
			// Update refs through assignment, not direct mutation
			// eslint-disable-next-line react-compiler/react-compiler -- Updating ref.current is the correct pattern for useRef
			hasProcessedInitialReset.current = true;
			lastResetKeyRef.current = resetKey;
			return;
		}

		if (!shouldForceReset) {
			return;
		}

		actions.resetGridState();
		lastResetKeyRef.current = resetKey;
	}, [
		resetKey,
		shouldForceReset,
		actions,
		hasProcessedInitialReset,
		lastResetKeyRef,
	]);
};
